import baseLog from '../log';

const authLog = baseLog.scope('auth');
export default authLog;
